import { PeriodSliceState } from '@/store/insertPeriodSlice'
import { sectorRulesSlice } from '@/store/sectorRulesSlice'
import { convertPeriodToUnixInteger } from '@/utils/dateUtils'
import { useAppDispatch, useAppSelector } from './store'

export function useLoadUnavailableSectors() {
  const dispatch = useAppDispatch()

  const sectorRules = useAppSelector(sectorRulesSlice.selectors.rules)
  const preemptionCode = useAppSelector(
    sectorRulesSlice.selectors.preemptionCode
  )

  async function loadUnavailableSectors(period: PeriodSliceState['period']) {
    if (!sectorRules) {
      return dispatch(sectorRulesSlice.actions.resetUnavailableSectors())
    }
    const periodUnix = convertPeriodToUnixInteger(period)

    // check if there are "required" rules
    const payload = sectorRules.reduce<Record<string, string>>(
      (acc, sectorRule) => {
        switch (sectorRule.ruleType) {
          case 'arrival-date': {
            if (periodUnix !== null) {
              acc.endDate = String(periodUnix.end)
            }
            break
          }
          case 'preemption-code-validation': {
            if (preemptionCode !== null) {
              acc.preemptionCode = preemptionCode
            }
            break
          }
        }
        return acc
      },
      {}
    )

    if (Object.keys(payload).length > 0) {
      return dispatch(
        sectorRulesSlice.actions.loadUnavailableSectors(payload)
      ).unwrap()
    } else {
      return dispatch(sectorRulesSlice.actions.resetUnavailableSectors())
    }
  }

  return {
    loadUnavailableSectors,
  }
}
